import React from 'react';
import { MDXProvider } from '@mdx-js/react';

import { PullQuote } from './blocks/pull-quote';
import { FeatureList, NumberList } from './blocks/list';
import { Text } from './blocks/text';
import { Diptych } from './blocks/diptych';
import { Media } from './blocks/media';
import { BrowserMedia } from './blocks/browser-media';

export function MDXProse(props: React.ComponentProps<typeof MDXProvider>) {
  const { children } = props;

  return (
    <MDXProvider
      components={{
        PullQuote,
        FeatureList,
        NumberList,
        Text,
        Diptych,
        Media,
        BrowserMedia
      }}
    >
      {children}
    </MDXProvider>
  );
}
